import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const View = styled.button`
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;
    text-align: left;
    font-size: 14px;

    .fl & {
        font-family: 'Open Sans';
    }

    &:focus {
        outline: none;
    }
`;

const Title = styled.div`
    margin-bottom: 3px;
    font-size: 12px;
    font-weight: 300;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: #4a4a4a;
`;

const Icon = styled.img`
    height: 25px;
    margin-bottom: 12px;
    display: block;
`;

const Subtitle = styled.div`color: #4b5860;`;

const Batch = styled.span`
    width: 8px;
    height: 8px;
    margin-left: 12px;
    border-radius: 50%;
    display: inline-block;
    background-color: ${props => props.color};
`;

const SegmentButton = props => {
    return (
        <View onClick={props.onClick} className={props.className}>
            <Icon src={props.iconUrl} />
            <Title>{props.title}</Title>
            <Subtitle>
                <span>{props.subtitle}</span>
                {props.batchColor && <Batch color={props.batchColor} />}
            </Subtitle>
        </View>
    );
};

SegmentButton.defaultProps = {
    onClick: () => {},
};

SegmentButton.propTypes = {
    iconUrl: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    batchColor: PropTypes.string,
    onClick: PropTypes.func,
};

export default SegmentButton;



// WEBPACK FOOTER //
// ./src/components/shared/SegmentButton.js